import { auth } from '../firebase';

/**
 * Bearer header for `/api/*` calls. The backend takes the creator from this
 * token, so no request body carries a user id. Returns `null` when the user is
 * not signed in, so callers can report that instead of sending a doomed request.
 */
export async function authHeader(): Promise<{ Authorization: string } | null> {
  try {
    const idToken = await auth.currentUser?.getIdToken();
    if (!idToken) {
      return null;
    }
    return { Authorization: `Bearer ${idToken}` };
  } catch (error) {
    console.error('Error getting Firebase ID token:', error);
    return null;
  }
}
